var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconShares48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2256_11431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69614 35.5544C10.3923 35.5544 11.7673 34.1794 11.7673 32.4832C11.7673 30.7871 10.3923 29.4121 8.69614 29.4121C7 29.4121 5.625 30.7871 5.625 32.4832C5.625 34.1794 7 35.5544 8.69614 35.5544Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6776 23.6535C20.3737 23.6535 21.7487 22.2785 21.7487 20.5824C21.7487 18.8862 20.3737 17.5112 18.6776 17.5112C16.9814 17.5112 15.6064 18.8862 15.6064 20.5824C15.6064 22.2785 16.9814 23.6535 18.6776 23.6535Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6583 30.9475C30.3544 30.9475 31.7294 29.5725 31.7294 27.8763C31.7294 26.1802 30.3544 24.8052 28.6583 24.8052C26.9622 24.8052 25.5872 26.1802 25.5872 27.8763C25.5872 29.5725 26.9622 30.9475 28.6583 30.9475Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4081 17.8952C41.1042 17.8952 42.4792 16.5202 42.4792 14.8241C42.4792 13.1279 41.1042 11.7529 39.4081 11.7529C37.7119 11.7529 36.3369 13.1279 36.3369 14.8241C36.3369 16.5202 37.7119 17.8952 39.4081 17.8952Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8845 30.5509L17.3636 23.2358",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3347 22.1904L26.5598 25.7435",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7397 25.7439L37.4278 17.3838",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2256_11431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconShares48);
export default __webpack_public_path__ + "static/media/pictogramBeaconShares48.d7fdfce7cae8753cd28cbe3616f04005.svg";
export { ForwardRef as ReactComponent };